import { createIcon } from "@chakra-ui/react";

export const Warning = createIcon({
  displayName: "Warning",
  viewBox: "0 0 24 24",
  d: "M11.998 1c.666 0 1.28.352 1.618.928l10.125 17.25A1.872 1.872 0 0 1 22.123 22H1.873c-.67 0-1.293-.36-1.626-.942a1.883 1.883 0 0 1 .01-1.88L10.38 1.928A1.871 1.871 0 0 1 11.998 1zm0 6c-.623 0-1.125.502-1.125 1.125v5.25c0 .623.502 1.125 1.125 1.125.624 0 1.125-.502 1.125-1.125v-5.25c0-.623-.501-1.125-1.125-1.125zm1.5 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z",
  defaultProps: {
    "aria-label": "An exclamation mark within a triangle"
  }
});

export default Warning;
